module.exports = __webpack_public_path__ + "img/loading6.2327fe44.gif";